import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex-auto p-3" }
const _hoisted_2 = ["name"]
const _hoisted_3 = ["id", "type", "value"]
const _hoisted_4 = { class: "text-xs italic text-red-500 transition duration-300 ease-in-out" }


export default /*#__PURE__*/_defineComponent({
  __name: 'FormInput',
  props: {
    name: null,
    modelValue: null,
    type: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {



function handleInput(e: Event) {
  const value = (e.target as HTMLInputElement).value;
  emit('update:modelValue', value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "block text-lg font-medium text-gray-900",
      name: __props.name
    }, _toDisplayString(__props.name), 9, _hoisted_2),
    _createElementVNode("input", {
      id: __props.name,
      type: __props.type,
      class: "bg-gray-50 border focus:outline-none border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5",
      value: __props.modelValue,
      onInput: handleInput
    }, null, 40, _hoisted_3),
    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.error), 1)
  ]))
}
}

})